import React, { useEffect } from 'react';
import './Auth.css';

const Notification = ({ type, message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000); // Auto close after 5 seconds

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`notification ${type}`}>
            <span className="material-icons">
                {type === 'success' ? 'check_circle' : 'error'}
            </span>
            <span className="notification-message">{message}</span>
            <button className="notification-close" onClick={onClose}>
                <span className="material-icons">close</span>
            </button>
        </div>
    );
};

export default Notification; 